<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <template #item.isActive="{ data }">
      <v-tooltip top>
        <template #activator="{ on, attrs }">
          <v-icon
            class="mr-2"
            v-bind="attrs"
            :color="data.is_active ? 'success' : 'error'"
            v-on="on"
            @click="openModal(data)"
            v-text="data.is_active ? 'mdi-checkbox-marked-outline' :'mdi-close-circle-outline'"
          />
        </template>
        <span>{{ data.is_active ? 'Деактивировать паспорт' : 'Активировать паспорт' }}</span>
      </v-tooltip>
    </template>
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/PassportsList/table-headers'

import BTableSimple from './BTableSimple.vue'
import { createModalConfirm } from '@/helpers/createModalConfirm'
import { PassportApi } from '@/api/resources'

export default {
  name: 'BTablePassportTemplates',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
  methods: {
    async openModal(data) {
      const propsData = {
        mainText: `Вы уверены, что хотите ${data.is_active ? 'деактивировать ' : 'активировать'} Паспорт?`,
        action: () => this.passportActivate(data.id),
      }
      const modal = await createModalConfirm(this, propsData)
      modal.open()
    },
    async passportActivate(id) {
      const api = new PassportApi()
      try {
        await api.passportActivate(id)
        this.$emit('activate')
      } catch (e) {
        this.$notice.errors(e)
      }
    },
  },
}
</script>
